import { Point } from 'components/site/general/singleSelect/SelectedMarkerV2/Point';
import polylabel from 'polylabel';
import Draggable from 'react-draggable';
import { IXY } from 'react-give-me-map/dist/utils/map/mapTypes';
import styled from 'styled-components/macro';

interface Props {
    xyCoordinates: IXY[];
    onDrag: (diffX: number, diffY: number) => void;
    onDragEnd: (diffX: number, diffY: number) => void;
}

export const MovePoint = (props: Props) => {
    const getXyCoordinate = () => {
        if (props.xyCoordinates.length === 1) {
            return props.xyCoordinates[0];
        }
        if (props.xyCoordinates.length === 2) {
            return {
                x: (props.xyCoordinates[0].x + props.xyCoordinates[1].x) / 2,
                y: (props.xyCoordinates[0].y + props.xyCoordinates[1].y) / 2
            };
        }

        const [centerX, centerY] = polylabel([props.xyCoordinates.map(({ x, y }) => [x, y])]);
        return {
            x: centerX,
            y: centerY
        };
    };

    const xyCoordinate = getXyCoordinate();

    return (
        <S_MovePoint>
            <Draggable
                axis="both"
                handle=".handle"
                defaultClassName="handleContainer"
                position={xyCoordinate}
                scale={1}
                onDrag={(_, data) => {
                    const xDiff = data.x - xyCoordinate.x;
                    const yDiff = data.y - xyCoordinate.y;
                    props.onDrag(xDiff, yDiff);
                }}
                onStop={(_, data) => {
                    const xDiff = data.x - xyCoordinate.x;
                    const yDiff = data.y - xyCoordinate.y;
                    props.onDragEnd(xDiff, yDiff);
                }}
            >
                <div>
                    <Point
                        className={'handle'}
                        width={20}
                        fontSize={12}
                        style={{
                            pointerEvents: 'all',
                            position: 'relative',
                            top: 0
                        }}
                        text={''}
                        icon={{
                            iconPrefix: 'far',
                            iconName: 'arrows-up-down-left-right'
                        }}
                        color={'#fff'}
                    />
                </div>
            </Draggable>
        </S_MovePoint>
    );
};

const S_MovePoint = styled.div`
    .handleContainer {
        z-index: 3;
    }
`;
